export default __webpack_public_path__ + "static/media/client1.c2780146.png";